import { useLogisticaConfiguration } from "../../configurazione/LogisticaConfigurationProvider";
import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../../../Apiurl";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import RicercaAvanzataPochiCampi from "./RicercaAvanzataPochiCampi";
import RicercaAvanzataOrdiniPOP from "./RicercaAvanzataOrdiniPOP";
import FunzioniOrdiniPOP from "./FunzioniOrdiniPOP";
import FunzioniStampaPOP from "./FunzioniStampaPOP";
import { createPortal } from "react-dom";
import apriUrl from "../../../interfaccia/funzioniComuni/apriUrl";

const PARTENZA_DA_VERNANTE_TUTTI = "Vernante (tutti)";

function BarraRicercaOrdini({
  vista,
  setListaOrdini,
  setUrlRicerca,
  inputVuoto,
  urlRicerca,
  inputIniziale,
  selezioneCampiRicerca,
  setOrdineFunction,
  setResImport,
  perPage,
  page,
  setTotalRows,
  setUrlParametri,
  datiTendineOrdine,
  tema,
  ricerca,
  setRicerca,
  columnSort,
  directionSort,
  setPerPage,
  setPage,
  mobile,
  setGaranzia,
  setNuovaGaranzia,
  setListeOrdiniDaAltrove,
  setVistaConReset,
  filtroVeloce,
  setFiltroVeloce,
  listaOrdini,
  report,
  setReport,
  utente,
  fetchOrdini,
  columnControl,
}) {
  const { groups } = useLogisticaConfiguration();
  const PARTENZE_DA_VERNANTE_TUTTI = groups.vernanteMarro.members;

  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [popUpWindow, setPopUpWindow] = useState(false);
  const [showMoreViste, setShowMoreViste] = useState(false);
  const [statiModaOrdine, setStatiModaOrdine] = useState([]);
  const [magPerRicercheRapide, setMagPerRicercheRapide] = useState(
    ricerca?.["sped.Partenza_da ="] || "Tutti"
  );
  const canUseLogisticaFunctions = Boolean(
    utente?.permessiAPI?.["update:logistica"]
  );

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    console.log("cambio vista");
  }, [vista]);

  useEffect(() => {
    if (!token || (vista && vista !== "ordini" && vista !== "note")) {
      return;
    }
    const controller = new AbortController();
    fetch(apiUrl + "/logistica/ricerca/statiModaOrdine", {
      headers: { Authorization: "Bearer " + token },
      signal: controller.signal,
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!controller.signal.aborted) {
          setStatiModaOrdine(Array.isArray(data) ? data : []);
        }
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Errore nel caricamento stati MODA ordine", error);
        }
      });

    return () => controller.abort();
  }, [token, vista]);

  let datiBarra = selezioneCampiRicerca.logisticaBARRA;
  if (!vista || vista === "logistica" || vista === "note" || vista === "controlliCorrispettivi") {
    datiBarra = selezioneCampiRicerca.logisticaBARRA;
  } else if (vista === "articoli") {
    datiBarra = selezioneCampiRicerca.articoliBARRA;
  } else if (vista === "contabili") {
    datiBarra = selezioneCampiRicerca.contabiliBARRA;
  } else if (vista === "checkSparati") {
    datiBarra = selezioneCampiRicerca.checkSparatiBARRA;
  } else if (vista === "contabiliRimborsi") {
    datiBarra = selezioneCampiRicerca.contabiliRimborsiBARRA;
  } else if (vista === "garanzie") {
    datiBarra = selezioneCampiRicerca.garanzieBARRA;
  } else if (vista === "evasione") {
    datiBarra = selezioneCampiRicerca.evasioneBARRA;
  }

  const datiBarraConOpzioni = datiBarra.map((campo) => {
    if (campo.nome !== "statoModaOrdine") {
      return campo;
    }
    return {
      ...campo,
      dati: statiModaOrdine,
    };
  });

  const {
    tastoRefreshAspetto,
    tastoNuovoAspetto,
    tastoImportAspetto,
    tastoCercaAvanzataAspetto,
    tastoToolsAspetto,
    tastoHomeAspetto,
    tastoArticoliAspetto,
    tastoContabiliAspetto,
    tastoNoteAspetto,
    tastoAtteseAspetto,
    tastoGaranzieAspetto,
    tastoPiuAspetto,
    tastoMenoAspetto,
    tastoEvasioneAspetto,
  } = stilePulsanti;

  const tastoControlliCorrispettiviAspetto = (
    <div className="flex items-center" title="Controlli corrispettivi">
      <span className="material-icons">receipt_long</span>
      <span className="f7 b ml1">IVA</span>
    </div>
  );

  const cercaUltimiOrdini = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    setUrlRicerca(urlRicerca);
    const ricercaReset =
      vista === "note"
        ? { columnSort: "", directionSort: "", includeNote: "1" }
        : { columnSort: "", directionSort: "" };
    setRicerca(ricercaReset);
    fetchOrdini(1, urlRicerca, {
      ricerca: ricercaReset,
      headers: { Authorization: "Bearer " + token },
    });
  };

  const ricercaRapida = async function (stato, trovato) {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }

    //TODO FARE QUESTO USANDO stato,trovato + magPerRicercheRapide
    //FARE ANCHE TENDINA PER CAMBIARE magPerRicercheRapide
    setUrlRicerca(urlRicerca);
    let valoreTrovato = " NOT NULL";
    if (trovato) {
      valoreTrovato = trovato;
    } else if (!trovato) {
      valoreTrovato = "";
    }
    let nuovaRicerca = {
      ...inputVuoto,
      "sped.Stato_Ordine =": stato,
      "sped.Partenza_da =": magPerRicercheRapide,
      "a.trovato IS": valoreTrovato,
    };
    if (magPerRicercheRapide === PARTENZA_DA_VERNANTE_TUTTI) {
      nuovaRicerca = {
        ...inputVuoto,
        "sped.Stato_Ordine =": stato,
        "sped.Partenza_da IN": PARTENZE_DA_VERNANTE_TUTTI.slice(),
        "a.trovato IS": valoreTrovato,
      };
    } else if (magPerRicercheRapide === "Tutti") {
      nuovaRicerca = {
        ...inputVuoto,
        "sped.Stato_Ordine =": stato,
        "a.trovato IS": valoreTrovato,
      };
    }
    setRicerca(nuovaRicerca);
    fetchOrdini(1, urlRicerca, {
      ricerca: nuovaRicerca,
      headers: { Authorization: "Bearer " + token },
    });
  };

  const importaOrdini = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    fetch(apiUrl + "/logistica/ps/importaOrdiniDaPS", {
      headers: { Authorization: "Bearer " + token },
    })
      .then((resp) => resp.json())
      .then((data) => setResImport(data));
  };

  const importaTracking = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    fetch(apiUrl + "/logistica/ps/importaTrackingDaPS", {
      method: "PATCH",
      headers: { Authorization: "Bearer " + token },
    })
      .then((resp) => resp.json())
      .then((data) => setResImport(data));
  };

  const creaOrdine = function () {
    setOrdineFunction({
      spedEclifor: [
        {
          "ID Spedizione": "NUOVO",
          Stato_Ordine: "PREPARAZIONE",
        },
      ],
      articoliArr: [],
      resiErimborsiArr: [],
      noteArr: [],
    });
  };

  const setFinestra = function (e, finestra) {
    e.preventDefault();
    setPopUpWindow(finestra);
  };

  function chiudi(e) {
    e.preventDefault();
    setPopUpWindow(false);
  }

  const getCSV = async function () {
    let query;
    if (vista === "contabili") {
      query = "pagamentiRangeDataOrdini";
    } else if (vista === "contabiliRimborsi") {
      query = "rimborsiRangeDataMovimenti";
    } else {
      console.log("nessuna query specificata per questa vista");
    }
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    //console.log("ricerca",ricerca)
    fetch(
      apiUrl + "/contab/csv/" + query + "/?" + new URLSearchParams(ricerca),
      { headers: { Authorization: "Bearer " + token } }
    )
      .then((resp) => resp.json())
      .then((data) => apriUrl(data));
  };

  const getCSVordini = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    //console.log("ricerca",ricerca)
    fetch(
      apiUrl + "/logistica/csv/ordiniArticoli?" + new URLSearchParams(ricerca),
      { headers: { Authorization: "Bearer " + token } }
    )
      .then((resp) => resp.json())
      .then((data) => apriUrl(data));
  };

  const handleChangeFiltroVeloce = async function (evt) {
    const value = evt.target.value;
    try {
      setFiltroVeloce(value);
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato non nestato: " + err);
      throw err;
    }
  };

  return (
    <div
      className={"formRicercaOrizzontale pa2 flex justify-around items-center"}
    >
      {/* mobile */}
      {mobile && (
        <div className="flex dn-ns">
          <div
            className="dim pointer gruppoInputRicercaOrizzontale mr2"
            onClick={(e) => {
              setFinestra(e, "ricercaAvanzata");
            }}
          >
            <button title="Ricerca avanzata" aria-label="Ricerca avanzata" className=" tastoInputOrizzontale br3">
              {tastoCercaAvanzataAspetto}
            </button>
            <span className="ml2 nonSelezionabile dn db-ns ">
              Ricerca avanzata
            </span>
          </div>
          <div className="gruppoInputRicercaOrizzontale mr2">
            <button
              className="dim db dn-ns dn-m tastoInputOrizzontale br3"
              onClick={() => ricercaRapida("IN ATTESA", false)}
            >
              ATTESE
            </button>
          </div>
          {vista === "articoli" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button
                className="dim db dn-ns dn-m tastoInputOrizzontale br3"
                onClick={() => ricercaRapida("IN ATTESA", " NULL")}
              >
                ATT. DA CERCARE
              </button>
            </div>
          )}
          <div className="gruppoInputRicercaOrizzontale mr2">
            <button
              className="dim db dn-ns dn-m tastoInputOrizzontale br3"
              onClick={() => ricercaRapida("ETICHETTE", false)}
            >
              ETICHETTE
            </button>
          </div>
          <div className="gruppoInputRicercaOrizzontale db dn-ns">
            <select
              name="magPerRicercheRapide"
              id="magPerRicercheRapide"
              onChange={(e) => setMagPerRicercheRapide(e.target.value)}
              value={magPerRicercheRapide}
              className="inputOrizzontale"
            >
              <option key="1" value="Villanova Mondovì">
                VILLANOVA
              </option>
              <option key="2" value="Torino">
                TO
              </option>
              <option key="3" value="Prato Nevoso">
                PRATO
              </option>
              <option key="4" value="Vernante">
                VERNANTE
              </option>
              <option key="5" value="Limone 1400">
                LI 1400
              </option>
              <option key="6" value="Borgo San Dalmazzo">
                BORGO
              </option>
              <option key="7" value="Limone">
                LIMONE
              </option>
              <option key="8" value="Vernante (tutti)">
                {groups.vernanteMarro.label}
              </option>
              <option key="9" value="Magazzino Marro (area VS)">
                MARRO VS
              </option>
              <option key="10" value="Magazzino Marro">
                MARRO
              </option>
            </select>
          </div>
          {/* /////////////////////////// */}
        </div>
      )}
      {/* desktop */}
      {!mobile && vista !== "checkSparati" && (
        <div className="selezioneVista flex">
          {vista !== "ordini" && vista && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista ordini" aria-label="Vista ordini"
                className="dim tastoInputOrizzontaleBianco br3"
                onClick={(e) =>
                  setVistaConReset(
                    e,
                    "ordini",
                    apiUrl +
                      "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/",
                    200
                  )
                }
              >
                {tastoHomeAspetto}
              </button>
            </div>
          )}
          {(!vista || vista === "ordini") && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista ordini" aria-label="Vista ordini" className="dim tastoInputOrizzontaleBiancoInvertito br3">
                {tastoHomeAspetto}
              </button>
            </div>
          )}
          {vista !== "articoli" &&
            vista !== "contabili" &&
            vista !== "contabiliRimborsi" &&
            vista !== "controlliCorrispettivi" && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Vista articoli" aria-label="Vista articoli"
                  className="dim tastoInputOrizzontaleBianco br3"
                  onClick={(e) =>
                    setVistaConReset(
                      e,
                      "articoli",
                      apiUrl +
                        "/logistica/ricerca/ricercaOrdiniDBArticoliavanzataPagination/",
                      10
                    )
                  }
                >
                  {tastoArticoliAspetto}
                </button>
              </div>
            )}
          {vista === "articoli" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista articoli" aria-label="Vista articoli" className="dim tastoInputOrizzontaleBiancoInvertito br3">
                {tastoArticoliAspetto}
              </button>
            </div>
          )}
          {!showMoreViste && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Mostra altre viste" aria-label="Mostra altre viste"
                className="dim tastoInputOrizzontaleBiancoAlt br3"
                onClick={() => setShowMoreViste(!showMoreViste)}
              >
                {tastoPiuAspetto}
              </button>
            </div>
          )}
          {showMoreViste && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Nascondi altre viste" aria-label="Nascondi altre viste"
                className="dim tastoInputOrizzontaleBiancoAlt br3"
                onClick={() => setShowMoreViste(!showMoreViste)}
              >
                {tastoMenoAspetto}
              </button>
            </div>
          )}
          {showMoreViste &&
            canUseLogisticaFunctions &&
            vista !== "evasione" &&
            vista !== "contabili" &&
            vista !== "contabiliRimborsi" &&
            vista !== "controlliCorrispettivi" && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Vista evasione" aria-label="Vista evasione"
                  className="dim tastoInputOrizzontaleBianco br3"
                  onClick={(e) =>
                    setVistaConReset(
                      e,
                      "evasione",
                      apiUrl + "/logistica/ricerca/ricercaEvasione/",
                      200
                    )
                  }
                >
                  {tastoEvasioneAspetto}
                </button>
              </div>
            )}
          {vista === "evasione" && canUseLogisticaFunctions && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista evasione" aria-label="Vista evasione" className="dim tastoInputOrizzontaleBiancoInvertito br3">
                {tastoEvasioneAspetto}
              </button>
            </div>
          )}
          {showMoreViste &&
            vista !== "note" &&
            vista !== "contabili" &&
            vista !== "contabiliRimborsi" &&
            vista !== "controlliCorrispettivi" && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Vista note" aria-label="Vista note"
                  className="dim tastoInputOrizzontaleBianco br3"
                  onClick={(e) =>
                    setVistaConReset(
                      e,
                      "note",
                      apiUrl +
                        "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/",
                      200
                    )
                  }
                >
                  {tastoNoteAspetto}
                </button>
              </div>
            )}
          {vista === "note" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista note" aria-label="Vista note" className="dim tastoInputOrizzontaleBiancoInvertito br3">
                {tastoNoteAspetto}
              </button>
            </div>
          )}
          {showMoreViste &&
            vista !== "attese" &&
            vista !== "contabili" &&
            vista !== "contabiliRimborsi" &&
            vista !== "controlliCorrispettivi" && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Vista attese" aria-label="Vista attese"
                  className="dim tastoInputOrizzontaleBianco br3"
                  onClick={(e) =>
                    setVistaConReset(
                      e,
                      "attese",
                      apiUrl + "/logistica/ricerca/ricercaAttese/",
                      10
                    )
                  }
                >
                  {tastoAtteseAspetto}
                </button>
              </div>
            )}
          {vista === "attese" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista attese" aria-label="Vista attese" className="dim tastoInputOrizzontaleBiancoInvertito br3">
                {tastoAtteseAspetto}
              </button>
            </div>
          )}
          {showMoreViste &&
            vista !== "garanzie" &&
            vista !== "contabili" &&
            vista !== "contabiliRimborsi" &&
            vista !== "controlliCorrispettivi" && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Vista garanzie" aria-label="Vista garanzie"
                  className="dim tastoInputOrizzontaleBianco br3"
                  onClick={(e) =>
                    setVistaConReset(
                      e,
                      "garanzie",
                      apiUrl + "/logistica/garanzia/ricercaGaranzie/",
                      50
                    )
                  }
                >
                  {tastoGaranzieAspetto}
                </button>
              </div>
            )}
          {vista === "garanzie" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista garanzie" aria-label="Vista garanzie" className="dim tastoInputOrizzontaleBiancoInvertito br3">
                {tastoGaranzieAspetto}
              </button>
            </div>
          )}
          {showMoreViste &&
            vista !== "contabili" &&
            vista !== "contabiliRimborsi" &&
            vista !== "controlliCorrispettivi" && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Vista pagamenti" aria-label="Vista pagamenti"
                  className="dim tastoInputOrizzontaleBianco br3"
                  onClick={(e) =>
                    setVistaConReset(
                      e,
                      "contabili",
                      apiUrl + "/contab/get/pagamentiRangeDataOrdini/",
                      10
                    )
                  }
                >
                  {tastoContabiliAspetto}
                </button>
              </div>
            )}
          {vista === "contabili" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button className="dim tastoInputOrizzontaleBiancoInvertito br3" title="Vista pagamenti">
                PAGAMENTI
              </button>
            </div>
          )}
          {showMoreViste &&
            vista !== "controlliCorrispettivi" &&
            vista !== "contabili" &&
            vista !== "contabiliRimborsi" && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Vista controlli corrispettivi" aria-label="Vista controlli corrispettivi"
                  className="dim tastoInputOrizzontaleBianco br3"
                  onClick={(e) =>
                    setVistaConReset(
                      e,
                      "controlliCorrispettivi",
                      apiUrl +
                        "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/",
                      200
                    )
                  }
                >
                  {tastoControlliCorrispettiviAspetto}
                </button>
              </div>
            )}
          {vista === "controlliCorrispettivi" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button title="Vista controlli corrispettivi" aria-label="Vista controlli corrispettivi" className="dim tastoInputOrizzontaleBiancoInvertito br3">
                {tastoControlliCorrispettiviAspetto}
              </button>
            </div>
          )}
          {vista === "contabiliRimborsi" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button
                title="Vista pagamenti"
                className="dim tastoInputOrizzontaleBianco br3"
                onClick={(e) =>
                  setVistaConReset(
                    e,
                    "contabili",
                    apiUrl + "/contab/get/pagamentiRangeDataOrdini/",
                    15
                  )
                }
              >
                PAGAMENTI
              </button>
            </div>
          )}
          {vista === "contabili" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button
                title="Vista rimborsi"
                className="dim tastoInputOrizzontaleBianco br3"
                onClick={(e) =>
                  setVistaConReset(
                    e,
                    "contabiliRimborsi",
                    apiUrl + "/contab/get/rimborsiRangeDataMovimenti/",
                    15
                  )
                }
              >
                RIMBORSI
              </button>
            </div>
          )}
          {vista === "contabiliRimborsi" && (
            <div className="gruppoInputRicercaOrizzontale mr2">
              <button className="dim tastoInputOrizzontaleBiancoInvertito br3" title="Vista rimborsi">
                RIMBORSI
              </button>
            </div>
          )}
        </div>
      )}
      <div className="barraSelezionata dn flex-ns">
        {vista !== "checkSparati" && (
          <div className="flex justify-center">
            {(!vista || vista === "ordini" || vista === "evasione" || vista === "note" || vista === "controlliCorrispettivi" ) && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Aggiorna ordini" aria-label="Aggiorna ordini"
                  className="dim tastoInputOrizzontale br3"
                  onClick={cercaUltimiOrdini}
                >
                  {tastoRefreshAspetto}
                </button>
              </div>
            )}
            {(!vista || vista === "ordini" || vista === "evasione" || vista === "note" || vista === "controlliCorrispettivi" ) && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Ricerca avanzata" aria-label="Ricerca avanzata"
                  className="dim tastoInputOrizzontale br3"
                  onClick={(e) => {
                    setFinestra(e, "ricercaAvanzata");
                  }}
                >
                  {tastoCercaAvanzataAspetto}
                </button>
              </div>
            )}
            {(!vista || vista === "ordini" || vista === "note" ) && canUseLogisticaFunctions && (
              <div className="gruppoInputRicercaOrizzontale mr2">
                <button title="Strumenti ordini" aria-label="Strumenti ordini"
                  className="dim tastoInputOrizzontale br3"
                  onClick={(e) => {
                    setFinestra(e, "funzioni");
                  }}
                >
                  {tastoToolsAspetto}
                </button>
              </div>
            )}
            {vista === "articoli" && (
              <div
                className="dim pointer gruppoInputRicercaOrizzontale mr2"
                onClick={getCSVordini}
              >
                <button className=" tastoInputOrizzontale br3">
                  {tastoImportAspetto}
                </button>
                <span className="ml2 nonSelezionabile dn db-ns ">CSV</span>
              </div>
            )}
            {(vista === "articoli" ||
              vista === "contabili" ||
              vista === "contabiliRimborsi" ||
              vista === "garanzie") && (
              <div
                className="dim pointer gruppoInputRicercaOrizzontale mr2"
                onClick={(e) => {
                  setFinestra(e, "ricercaAvanzata");
                }}
              >
                <button title="Ricerca avanzata" aria-label="Ricerca avanzata" className=" tastoInputOrizzontale br3">
                  {tastoCercaAvanzataAspetto}
                </button>
                <span className="ml2 nonSelezionabile dn db-ns ">
                  Ricerca avanzata
                </span>
              </div>
            )}
            {(!vista || vista === "ordini" || vista === "articoli" || vista === "note" ) && (
              <div
                className="dim pointer gruppoInputRicercaOrizzontale mr3"
                onClick={(e) => {
                  setFinestra(e, "stampa");
                }}
              >
                <button title="Stampa ordini" aria-label="Stampa ordini" className="tastoInputOrizzontale br3">
                  {stilePulsanti.tastoStampaAspetto}
                </button>
                {vista === "articoli" && <span>STAMPA</span>}
              </div>
            )}

            {!report && vista === "articoli" && (
              <div className="flex">
                <div
                  className="dim pointer gruppoInputRicercaOrizzontale mr2"
                  onClick={() => setReport(true)}
                >
                  {"REPORT"}
                </div>
                <div className="gruppoInputRicercaOrizzontale mr2">
                  <button
                    className={stilePulsanti.buttonClassesWhite + " br3"}
                    onClick={() => ricercaRapida("PREPARAZIONE", false)}
                  >
                    {"PREPARAZIONE " + magPerRicercheRapide}
                  </button>
                </div>
                <div className="gruppoInputRicercaOrizzontale mr2">
                  <button
                    className={stilePulsanti.buttonClassesWhite + " br3"}
                    onClick={() => ricercaRapida("RICERCA", false)}
                  >
                    {"RICERCA " + magPerRicercheRapide}
                  </button>
                </div>
                <div className="gruppoInputRicercaOrizzontale">
                  <select
                    name="magPerRicercheRapide"
                    id="magPerRicercheRapide"
                    onChange={(e) => setMagPerRicercheRapide(e.target.value)}
                    value={magPerRicercheRapide}
                    className="mr2"
                  >
                    <option key="1" value="Villanova Mondovì">
                      VILLANOVA
                    </option>
                    <option key="2" value="Torino">
                      TO
                    </option>
                    <option key="3" value="Prato Nevoso">
                      PRATO
                    </option>
                    <option key="4" value="Vernante">
                      VERNANTE
                    </option>
                    <option key="5" value="Limone 1400">
                      LI 1400
                    </option>
                    <option key="6" value="Borgo San Dalmazzo">
                      BORGO
                    </option>
                    <option key="7" value="Limone">
                      LIMONE
                    </option>
              <option key="8" value="Vernante (tutti)">
                {groups.vernanteMarro.label}
              </option>
              <option key="9" value="Magazzino Marro (area VS)">
                MARRO VS
              </option>
              <option key="10" value="Magazzino Marro">
                MARRO
              </option>
                  </select>
                </div>
              </div>
            )}
            {report && vista === "articoli" && (
              <div className="flex">
                <div
                  className="dim pointer gruppoInputRicercaOrizzontale mr2"
                  onClick={() => setReport(false)}
                >
                  {"INDIETRO"}
                </div>
              </div>
            )}
            {(vista === "contabili" || vista === "contabiliRimborsi") && (
              <div
                className="dim pointer gruppoInputRicercaOrizzontale mr2"
                onClick={getCSV}
              >
                <button className=" tastoInputOrizzontale br3">
                  {tastoImportAspetto}
                </button>
                <span className="ml2 nonSelezionabile">CSV</span>
              </div>
            )}
            {vista === "garanzie" && canUseLogisticaFunctions && (
              <div
                className="dim pointer gruppoInputRicercaOrizzontale mr2"
                onClick={() => {
                  setPage(1);
                  setPerPage(perPage);
                  setUrlRicerca(false);
                  setListeOrdiniDaAltrove(false);
                  setGaranzia(false);
                  setNuovaGaranzia(true);
                }}
              >
                <button className=" tastoInputOrizzontale br3">
                  {tastoNuovoAspetto}
                </button>
                <span className="ml2 nonSelezionabile">NUOVA GARANZIA</span>
              </div>
            )}
          </div>
        )}
      </div>
      {/* //questi sono in un div a parte */}
      {popUpWindow === "ricercaAvanzata" && (!vista || vista === "ordini" || vista === "note" || vista === "controlliCorrispettivi") && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              {/* desktop */}
              <div className={tema + " finestraPopUp"}>
                <RicercaAvanzataOrdiniPOP
                  setUrlRicerca={setUrlRicerca}
                  setUrlParametri={setUrlParametri}
                  page={page}
                  perPage={perPage}
                  setTotalRows={setTotalRows}
                  setListaOrdini={setListaOrdini}
                  datiTendineOrdine={datiTendineOrdine}
                  setPopUpWindow={setPopUpWindow}
                  campiRicerca={selezioneCampiRicerca.logisticaAvanzata}
                  inputIniziale={inputIniziale}
                  urlRicercaVista={urlRicerca}
                  vista={vista}
                  setRicerca={setRicerca}
                  columnSort={columnSort}
                  directionSort={directionSort}
                  fetchOrdini={fetchOrdini}
                />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow === "funzioni" && canUseLogisticaFunctions && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              <div
                className={"bg-white " + tema + " finestraPopUp"}
                style={{
                  width: "95vw",
                  maxWidth: "1600px",
                  height: "92vh",
                  maxHeight: "92vh",
                  overflow: "hidden"
                }}
              >
                <FunzioniOrdiniPOP
                  setPopUpWindow={setPopUpWindow}
                  creaOrdine={creaOrdine}
                  importaOrdini={importaOrdini}
                  importaTracking={importaTracking}
                  tema={tema}
                />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow === "stampa" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              <div
                className={"bg-white " + tema + " finestraPopUp"}
                style={{
                  width: "95vw",
                  maxWidth: "1600px",
                  height: "92vh",
                  maxHeight: "92vh",
                  overflow: "hidden"
                }}
              >
                <FunzioniStampaPOP
                  setPopUpWindow={setPopUpWindow}
                  tema={tema}
                  datiTendineOrdine={datiTendineOrdine}
                  ordiniSelezionati={listaOrdini ? listaOrdini : false}
                  vista={vista}
                />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow === "ricercaAvanzata" && vista === "articoli" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              {/* desktop */}
              <div
                className={"bg-white " + tema + " finestraPopUp"}
                style={{
                  width: "98vw",
                  maxWidth: "1780px",
                  height: "92vh",
                  maxHeight: "92vh",
                  left: "50%",
                  transform: "translateX(-50%)",
                  overflow: "hidden",
                }}
              >
                <RicercaAvanzataOrdiniPOP
                  setUrlRicerca={setUrlRicerca}
                  setUrlParametri={setUrlParametri}
                  page={page}
                  perPage={perPage}
                  setTotalRows={setTotalRows}
                  setListaOrdini={setListaOrdini}
                  datiTendineOrdine={datiTendineOrdine}
                  setPopUpWindow={setPopUpWindow}
                  campiRicerca={selezioneCampiRicerca.articoliAvanzata}
                  inputIniziale={inputIniziale}
                  urlRicercaVista={urlRicerca}
                  vista={vista}
                  setRicerca={setRicerca}
                  columnSort={columnSort}
                  directionSort={directionSort}
                  fetchOrdini={fetchOrdini}
                />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow === "ricercaAvanzata" && vista === "contabili" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              {/* desktop */}
              <div className={tema + " finestraPopUp"}>
                <RicercaAvanzataOrdiniPOP
                  setUrlRicerca={setUrlRicerca}
                  setUrlParametri={setUrlParametri}
                  page={page}
                  perPage={perPage}
                  setTotalRows={setTotalRows}
                  setListaOrdini={setListaOrdini}
                  datiTendineOrdine={datiTendineOrdine}
                  setPopUpWindow={setPopUpWindow}
                  campiRicerca={selezioneCampiRicerca.contabiliAvanzata}
                  inputIniziale={inputIniziale}
                  urlRicercaVista={urlRicerca}
                  vista={vista}
                  setRicerca={setRicerca}
                  columnSort={columnSort}
                  directionSort={directionSort}
                  fetchOrdini={fetchOrdini}
                />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow === "ricercaAvanzata" && vista === "contabiliRimborsi" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              {/* desktop */}
              <div className={tema + " finestraPopUp"}>
                <RicercaAvanzataOrdiniPOP
                  setUrlRicerca={setUrlRicerca}
                  setUrlParametri={setUrlParametri}
                  page={page}
                  perPage={perPage}
                  setTotalRows={setTotalRows}
                  setListaOrdini={setListaOrdini}
                  datiTendineOrdine={datiTendineOrdine}
                  setPopUpWindow={setPopUpWindow}
                  campiRicerca={selezioneCampiRicerca.contabiliRimborsiAvanzata}
                  inputIniziale={inputIniziale}
                  urlRicercaVista={urlRicerca}
                  vista={vista}
                  setRicerca={setRicerca}
                  columnSort={columnSort}
                  directionSort={directionSort}
                  fetchOrdini={fetchOrdini}
                />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow === "ricercaAvanzata" && vista === "garanzie" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              {/* desktop */}
              <div className={tema + " finestraPopUp"}>
                <RicercaAvanzataOrdiniPOP
                  setUrlRicerca={setUrlRicerca}
                  setUrlParametri={setUrlParametri}
                  page={page}
                  perPage={perPage}
                  setTotalRows={setTotalRows}
                  setListaOrdini={setListaOrdini}
                  datiTendineOrdine={datiTendineOrdine}
                  setPopUpWindow={setPopUpWindow}
                  campiRicerca={selezioneCampiRicerca.garanzieAVANZATA}
                  inputIniziale={inputIniziale}
                  urlRicercaVista={urlRicerca}
                  vista={vista}
                  setRicerca={setRicerca}
                  columnSort={columnSort}
                  directionSort={directionSort}
                  fetchOrdini={fetchOrdini}
                />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}

      {/* ////////////////////////////////////////////////////////////////////////// */}
      {!report && (
        <div className="w-85 dn db-ns">
          <RicercaAvanzataPochiCampi
            vista={vista}
            setUrlRicerca={setUrlRicerca}
            setUrlParametri={setUrlParametri}
            page={page}
            perPage={perPage}
            setTotalRows={setTotalRows}
            setListaOrdini={setListaOrdini}
            datiTendineOrdine={datiTendineOrdine}
            campiRicerca={datiBarraConOpzioni}
            inputIniziale={inputIniziale}
            urlRicerca={urlRicerca}
            setRicerca={setRicerca}
            columnSort={columnSort}
            directionSort={directionSort}
            ricerca={ricerca}
            inputVuoto={inputVuoto}
            fetchOrdini={fetchOrdini}
            columnControl={columnControl}
          />
        </div>
      )}
      {mobile && (
        <div className="gruppoInputRicercaOrizzontale ml2 w-20">
          <input
            value={filtroVeloce}
            name="filtroVeloce"
            onChange={handleChangeFiltroVeloce}
            id="filtroVeloce"
            className="input-reset inputOrizzontale"
            type="number"
            placeholder="n. ordine"
            aria-describedby="name-desc"
            autoComplete="off"
          />
        </div>
      )}
    </div>
  );
}

export default BarraRicercaOrdini;
